const keyMirror = require("keymirror");

export const HomeConstants = keyMirror({
  FETCH_USER_DETAILS: undefined
});
